export default "__VITE_ASSET__BQQfzAQz__"